import "./parts/form";

const isQuestionableCountry = (country) => {
  return country_filter_data.countries.some((el) => el.country === country);
};

const formSections = document.querySelectorAll(".form_content_section");
if (formSections) {
  Array.prototype.forEach.call(formSections, (formSection) => {
    const form = formSection.querySelector("form");
    if (form) {
      const hiddenField = form.querySelector(".hd-ctr-field");
      if (hiddenField) {
        const hiddenInput = hiddenField.querySelector("input");
        if (hiddenInput) {
          const countrySessionData = sessionStorage.getItem("ipCountry");

          if (countrySessionData) {
            hiddenInput.value = isQuestionableCountry(countrySessionData);
          } else {
            let ipCountry;
            const request = new XMLHttpRequest();

            request.open(
              "GET",
              "https://api.ipdata.co/?api-key=8ee7c8388e4d89671d68902eb20d85fabc0e851f0e2fbf2b9495eb37"
            );

            request.setRequestHeader("Accept", "application/json");
            request.onreadystatechange = function () {
              if (this.readyState === 4) {
                ipCountry = JSON.parse(this.responseText).country_name;
                sessionStorage.setItem("ipCountry", ipCountry);
                hiddenInput.value = isQuestionableCountry(ipCountry);
              }
            };
            request.send();
          }
        }
      }
    }
  });
}
